export default function loader() {
  setTimeout(function() {
    $(".loader").fadeOut("slow");
    Aos.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, 1000);
}
